import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { PlaySvg } from './Play';

export const PlayIcon = createIcon('play', PlaySvg);
/**
 * @deprecated используйте PlayIcon
 */
export const withPlayIcon = withIcon('play', PlaySvg);
